
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.default || mod) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
  }
}
import { default as _91id_93bWzw0R0wOvMeta } from "/app/pages/admin/articles/[id].vue?macro=true";
import { default as indexdAKPN4X9V0Meta } from "/app/pages/admin/articles/index.vue?macro=true";
import { default as indexkJM8Q7EhnRMeta } from "/app/pages/admin/broadcasts/index.vue?macro=true";
import { default as configH6FVNPw6E4Meta } from "/app/pages/admin/documents/[eventId]/config.vue?macro=true";
import { default as indexL9pJJDGSYWMeta } from "/app/pages/admin/documents/[eventId]/index.vue?macro=true";
import { default as _91id_93odSjrdLQRsMeta } from "/app/pages/admin/events/[id].vue?macro=true";
import { default as indexFSe3tm7kZtMeta } from "/app/pages/admin/events/index.vue?macro=true";
import { default as _91id_93ZFu2tvdmG2Meta } from "/app/pages/admin/exchange/[eventId]/[id].vue?macro=true";
import { default as configY9fTUGqlUFMeta } from "/app/pages/admin/exchange/[eventId]/config.vue?macro=true";
import { default as indexU5CbIIX5PqMeta } from "/app/pages/admin/exchange/[eventId]/index.vue?macro=true";
import { default as configpGXeeAehqxMeta } from "/app/pages/admin/lottery/[eventId]/config.vue?macro=true";
import { default as indexdFPu5DhyDtMeta } from "/app/pages/admin/lottery/[eventId]/index.vue?macro=true";
import { default as create3HLTY2HwCRMeta } from "/app/pages/admin/messages/create.vue?macro=true";
import { default as _91id_937JlZMvtffDMeta } from "/app/pages/admin/messages/detail/[id].vue?macro=true";
import { default as indexP9xRqMxlIeMeta } from "/app/pages/admin/messages/index.vue?macro=true";
import { default as _91id_937GMDezaR8hMeta } from "/app/pages/admin/profiles/[eventId]/[id].vue?macro=true";
import { default as indexN9hmvZ8RsrMeta } from "/app/pages/admin/profiles/[eventId]/index.vue?macro=true";
import { default as _91id_93tcl7WoZXLcMeta } from "/app/pages/admin/signup/[eventId]/[id].vue?macro=true";
import { default as indexByXFLxt2vgMeta } from "/app/pages/admin/signup/[eventId]/index.vue?macro=true";
import { default as siteoM8xqEWznaMeta } from "/app/pages/admin/site.vue?macro=true";
import { default as _91id_936l8sqxZZT0Meta } from "/app/pages/admin/upload/[eventId]/[id].vue?macro=true";
import { default as configOhOH3S3Qk7Meta } from "/app/pages/admin/upload/[eventId]/config.vue?macro=true";
import { default as indexkpV7oWvD2kMeta } from "/app/pages/admin/upload/[eventId]/index.vue?macro=true";
import { default as admin0eiku7Jj1aMeta } from "/app/pages/admin.vue?macro=true";
import { default as change_45passwordfuKXk97OTTMeta } from "/app/pages/app/change-password.vue?macro=true";
import { default as _91id_93wZOrefTsv0Meta } from "/app/pages/app/documents/[id].vue?macro=true";
import { default as _91id_93tRuTBBzjqQMeta } from "/app/pages/app/exchange/[id].vue?macro=true";
import { default as indexbUTYpCP6oZMeta } from "/app/pages/app/index.vue?macro=true";
import { default as _91id_93v90Ds40d22Meta } from "/app/pages/app/lottery/[id].vue?macro=true";
import { default as _91id_93qtijuQo2eCMeta } from "/app/pages/app/messages/detail/[id].vue?macro=true";
import { default as indexCXSIOIi413Meta } from "/app/pages/app/messages/index.vue?macro=true";
import { default as profilesqA8n8mzVY2Meta } from "/app/pages/app/profiles.vue?macro=true";
import { default as _91id_93J3ZTv9LPJqMeta } from "/app/pages/app/scores/[id].vue?macro=true";
import { default as _91id_939ZuwutlWU2Meta } from "/app/pages/app/upload/[id].vue?macro=true";
import { default as appuxecjmUeNfMeta } from "/app/pages/app.vue?macro=true";
import { default as _91id_93GfbQespuG8Meta } from "/app/pages/articles/[id].vue?macro=true";
import { default as indexnFjuerN8cOMeta } from "/app/pages/articles/index.vue?macro=true";
import { default as adminGfgdlvbLVsMeta } from "/app/pages/auth/admin.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as qnaOcmbv6xM1wMeta } from "/app/pages/qna.vue?macro=true";
import { default as signinUhHmpbjN2pMeta } from "/app/pages/signin.vue?macro=true";
import { default as signupezBbZGXKU6Meta } from "/app/pages/signup.vue?macro=true";
import { default as indexskGUjQR8MiMeta } from "/app/pages/timer/index.vue?macro=true";
import { default as story3AAYOrJCUAMeta } from "/app/pages/timer/story.js?macro=true";
export default [
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin.vue"),
    children: [
  {
    name: "admin-articles-id",
    path: "articles/:id()",
    component: () => import("/app/pages/admin/articles/[id].vue")
  },
  {
    name: "admin-articles",
    path: "articles",
    component: () => import("/app/pages/admin/articles/index.vue")
  },
  {
    name: "admin-broadcasts",
    path: "broadcasts",
    component: () => import("/app/pages/admin/broadcasts/index.vue")
  },
  {
    name: "admin-documents-eventId-config",
    path: "documents/:eventId()/config",
    component: () => import("/app/pages/admin/documents/[eventId]/config.vue")
  },
  {
    name: "admin-documents-eventId",
    path: "documents/:eventId()",
    component: () => import("/app/pages/admin/documents/[eventId]/index.vue")
  },
  {
    name: "admin-events-id",
    path: "events/:id()",
    component: () => import("/app/pages/admin/events/[id].vue")
  },
  {
    name: "admin-events",
    path: "events",
    component: () => import("/app/pages/admin/events/index.vue")
  },
  {
    name: "admin-exchange-eventId-id",
    path: "exchange/:eventId()/:id()",
    component: () => import("/app/pages/admin/exchange/[eventId]/[id].vue")
  },
  {
    name: "admin-exchange-eventId-config",
    path: "exchange/:eventId()/config",
    component: () => import("/app/pages/admin/exchange/[eventId]/config.vue")
  },
  {
    name: "admin-exchange-eventId",
    path: "exchange/:eventId()",
    component: () => import("/app/pages/admin/exchange/[eventId]/index.vue")
  },
  {
    name: "admin-lottery-eventId-config",
    path: "lottery/:eventId()/config",
    component: () => import("/app/pages/admin/lottery/[eventId]/config.vue")
  },
  {
    name: "admin-lottery-eventId",
    path: "lottery/:eventId()",
    component: () => import("/app/pages/admin/lottery/[eventId]/index.vue")
  },
  {
    name: "admin-messages-create",
    path: "messages/create",
    component: () => import("/app/pages/admin/messages/create.vue")
  },
  {
    name: "admin-messages-detail-id",
    path: "messages/detail/:id()",
    component: () => import("/app/pages/admin/messages/detail/[id].vue")
  },
  {
    name: "admin-messages",
    path: "messages",
    component: () => import("/app/pages/admin/messages/index.vue")
  },
  {
    name: "admin-profiles-eventId-id",
    path: "profiles/:eventId()/:id()",
    component: () => import("/app/pages/admin/profiles/[eventId]/[id].vue")
  },
  {
    name: "admin-profiles-eventId",
    path: "profiles/:eventId()",
    component: () => import("/app/pages/admin/profiles/[eventId]/index.vue")
  },
  {
    name: "admin-signup-eventId-id",
    path: "signup/:eventId()/:id()",
    component: () => import("/app/pages/admin/signup/[eventId]/[id].vue")
  },
  {
    name: "admin-signup-eventId",
    path: "signup/:eventId()",
    component: () => import("/app/pages/admin/signup/[eventId]/index.vue")
  },
  {
    name: "admin-site",
    path: "site",
    component: () => import("/app/pages/admin/site.vue")
  },
  {
    name: "admin-upload-eventId-id",
    path: "upload/:eventId()/:id()",
    component: () => import("/app/pages/admin/upload/[eventId]/[id].vue")
  },
  {
    name: "admin-upload-eventId-config",
    path: "upload/:eventId()/config",
    component: () => import("/app/pages/admin/upload/[eventId]/config.vue")
  },
  {
    name: "admin-upload-eventId",
    path: "upload/:eventId()",
    component: () => import("/app/pages/admin/upload/[eventId]/index.vue")
  }
]
  },
  {
    name: appuxecjmUeNfMeta?.name,
    path: "/app",
    component: () => import("/app/pages/app.vue"),
    children: [
  {
    name: "app-change-password",
    path: "change-password",
    component: () => import("/app/pages/app/change-password.vue")
  },
  {
    name: "app-documents-id",
    path: "documents/:id()",
    component: () => import("/app/pages/app/documents/[id].vue")
  },
  {
    name: "app-exchange-id",
    path: "exchange/:id()",
    component: () => import("/app/pages/app/exchange/[id].vue")
  },
  {
    name: "app",
    path: "",
    component: () => import("/app/pages/app/index.vue")
  },
  {
    name: "app-lottery-id",
    path: "lottery/:id()",
    component: () => import("/app/pages/app/lottery/[id].vue")
  },
  {
    name: "app-messages-detail-id",
    path: "messages/detail/:id()",
    component: () => import("/app/pages/app/messages/detail/[id].vue")
  },
  {
    name: "app-messages",
    path: "messages",
    component: () => import("/app/pages/app/messages/index.vue")
  },
  {
    name: "app-profiles",
    path: "profiles",
    component: () => import("/app/pages/app/profiles.vue")
  },
  {
    name: "app-scores-id",
    path: "scores/:id()",
    component: () => import("/app/pages/app/scores/[id].vue")
  },
  {
    name: "app-upload-id",
    path: "upload/:id()",
    component: () => import("/app/pages/app/upload/[id].vue")
  }
]
  },
  {
    name: "articles-id",
    path: "/articles/:id()",
    component: () => import("/app/pages/articles/[id].vue")
  },
  {
    name: "articles",
    path: "/articles",
    component: () => import("/app/pages/articles/index.vue")
  },
  {
    name: "auth-admin",
    path: "/auth/admin",
    component: () => import("/app/pages/auth/admin.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "qna",
    path: "/qna",
    component: () => import("/app/pages/qna.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/app/pages/signin.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "timer",
    path: "/timer",
    component: () => import("/app/pages/timer/index.vue")
  },
  {
    name: "timer-story",
    path: "/timer/story",
    component: () => import("/app/pages/timer/story.js")
  }
]